export default function Loading() {
  return (
    <div className="prime-token-store-loader-wrap show-loading">
      <div className="loader"></div>
    </div>
  );
}
